export default __webpack_public_path__ + "static/assets/2063bee4ed14c36f728b755e0a86e77c.svg";